/**
 * D-026 — tint a race header with its mark's accent colour.
 *
 *   const accent = useRaceAccent(raceKey, trackId);
 *   <header {...raceAccentProps(accent)}>…</header>
 *
 * The race crest's `accent_hex` wins; a track mark's is the fallback; with
 * neither the header is untouched. `headerAccent` (lib/logoStore.ts) validates
 * the value as `#rrggbb` before it can reach a style.
 */

import type { CSSProperties } from 'react';
import '../raceAccent.css';
import { headerAccent, useLogos } from '../lib/logoStore.ts';

export function useRaceAccent(raceKey: string | null | undefined, trackId?: string | null): string | null {
  return headerAccent(useLogos(), raceKey, trackId);
}

/** Spread onto the header element. Empty when there is no accent. */
export function raceAccentProps(accent: string | null): { 'data-race-accent'?: string; style?: CSSProperties } {
  if (!accent) return {};
  return { 'data-race-accent': accent, style: { ['--race-accent' as string]: accent } as CSSProperties };
}
